import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../../../../services/auth.service';
import Swal from 'sweetalert2';
import './Auth.css';

const RequestPasswordReset = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setLoading(true);
        try {
            await authService.requestPasswordReset(email);
            Swal.fire({
                title: 'Solicitud Enviada',
                text: 'Si el correo existe en nuestros registros, recibirás un enlace para recuperar tu contraseña.',
                icon: 'success',
                confirmButtonColor: '#FF6B35'
            });
            navigate('/login');
        } catch (error) {
            console.error(error);
            const errorData = error.response?.data;
            if (errorData?.error === 'employee_must_contact_admin') {
                Swal.fire({
                    title: 'Acción no disponible',
                    text: errorData.message || 'Como empleado, debes contactar al administrador de tu empresa para restablecer tu contraseña.',
                    icon: 'info',
                    confirmButtonColor: '#FF6B35'
                });
            } else if (errorData?.error) {
                Swal.fire('Error', errorData.error, 'error');
            } else {
                Swal.fire('Error', 'Hubo un problema al procesar tu solicitud.', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-bg">
            <div className="visual-placeholder" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', overflow: 'hidden', zIndex: 0 }}>
                <div className="floating-circle circle-1"></div>
                <div className="floating-circle circle-2" style={{ bottom: '10%', left: '10%' }}></div>
            </div>

            <div className="login-container" style={{ zIndex: 1, position: 'relative' }}>
                <div className="login-card">
                    <div className="login-header">
                        <Link to="/" style={{ color: 'var(--text-secondary)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.9rem', fontWeight: 500, marginBottom: '15px' }}>
                            ← Volver al inicio
                        </Link>
                        <h2>Recuperar Contraseña</h2>
                        <p>Ingresa tu correo y te enviaremos las instrucciones</p>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group-custom">
                            <label className="form-label-custom">Email</label>
                            <input
                                type="email"
                                className="form-control-custom"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="tu@email.com"
                            />
                        </div>

                        <button type="submit" className="btn-custom btn-primary btn-full-width" disabled={loading} style={{ marginTop: '20px' }}>
                            {loading ? 'Enviando...' : 'Enviar Enlace'}
                        </button>

                        <div className="login-footer">
                            <p onClick={() => navigate('/login')}>Volver al Login</p>
                        </div>
                    </form>
                </div>

                <div className="login-info">
                    <h2>¿Olvidaste tu contraseña?</h2>
                    <p>No te preocupes, es común. Sigue los pasos para recuperarla:</p>
                    <ul>
                        <li>Ingresa tu correo registrado.</li>
                        <li>Revisa tu bandeja de entrada.</li>
                        <li>Sigue el enlace seguro.</li>
                        <li>Crea una nueva contraseña.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default RequestPasswordReset;
